/* eslint-disable */
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../pages/Home.vue";
import notFound from "../pages/404.vue";
import { getToken, setToken, removeToken } from "@/util/auth";
import { GetUserInfo } from "@/api/member";

import store from "../store/index";
// import { Message } from 'element-ui'

const Token = getToken() || null;

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    meta: {
      auth: false,
      title: "首页",
    },
    name: "home",
    component: Home,
  },
  {
    path: "/search",
    meta: { title: "搜索结果", auth: false, bg: "#F1F4F6" },
    name: "search",
    component: () => import("../pages/search/index.vue"),
  },
  {
    path: "/agreement",
    meta: { title: "筑才用户协议", auth: false, bg: "#F1F4F6" },
    name: "agreement",
    component: () => import("../pages/agreement/index.vue"),
  },
  {
    path: "/course",
    meta: { title: "课程中心", auth: false, bg: "#F1F4F6" },
    name: "course",
    component: () => import("../pages/course/index.vue"),
  },
  {
    path: "/column",
    meta: { title: "", auth: false, bg: "#F1F4F6" },
    name: "column",
    component: () => import("../pages/column/index.vue"),
  },
  {
    path: "/courseDetail",
    meta: { title: "课程详情", auth: false, bg: "#F1F4F6" },
    name: "courseDetail",
    component: () => import("../pages/course/detail.vue"),
  },
  {
    path: "/chapterDetail",
    meta: { title: "课程章节详情", auth: false, bg: "#F1F4F6" },
    name: "chapterDetail",
    component: () => import("../pages/course/chapterDetail.vue"),
  },
  {
    path: "/confirmOrder",
    meta: { title: "确认订单", bg: "#F1F4F6" },
    name: "confirmOrder",
    component: () => import("../pages/confirmOrder/confirmOrder.vue"),
  },
  {
    path: "/orderResult",
    meta: { title: "订单结果", bg: "#F1F4F6" },
    name: "orderResult",
    component: () => import("../pages/confirmOrder/result.vue"),
  },
  {
    path: "/exam/detail",
    meta: { title: "课程考试", bg: "#F1F4F6" },
    name: "examDetail",
    component: () => import("../pages/exam/detail.vue"),
  },
  {
    path: "/exam/result",
    meta: { title: "考试结果", bg: "#F1F4F6" },
    name: "examResult",
    component: () => import("../pages/exam/result.vue"),
  },
  {
    path: "/exam/result2",
    meta: { title: "练习结果", bg: "#F1F4F6" },
    name: "examResult2",
    component: () => import("../pages/exam/result2.vue"),
  },
  {
    path: "/exam/result3",
    meta: { title: "练习结果", bg: "#F1F4F6" },
    name: "examResult3",
    component: () => import("../pages/exam/result3.vue"),
  },
  {
    path: "/material",
    meta: { title: "资料下载", auth: false, bg: "#F1F4F6" },
    name: "material",
    component: () => import("../pages/material/index.vue"),
  },
  {
    path: "/materialDetail",
    meta: { title: "资料详情", auth: false, bg: "#F1F4F6" },
    name: "materialDetail",
    component: () => import("../pages/material/detail.vue"),
  },
  {
    path: "/qbank",
    meta: { title: "题库中心", auth: false, bg: "#F1F4F6" },
    name: "qbank",
    component: () => import("../pages/qbank/index.vue"),
  },
  {
    path: "/qbankDetail",
    meta: { title: "题库详情", auth: false, bg: "#F1F4F6" },
    name: "qbankDetail",
    component: () => import("../pages/qbank/detail.vue"),
  },
  {
    path: "/qbankCreate",
    meta: { title: "创建练习", bg: "#F1F4F6" },
    name: "qbankCreate",
    component: () => import("../pages/qbank/create.vue"),
  },
  {
    path: "/exam/exercises",
    meta: { title: "题库练习", bg: "#F1F4F6" },
    name: "exercises",
    component: () => import("../pages/exam/exercises.vue"),
  },
  {
    path: "/exam/wrong",
    meta: { title: "错题集", bg: "#F1F4F6" },
    name: "wrong",
    component: () => import("../pages/exam/wrong.vue"),
  },
  {
    path: "/teacher",
    meta: { title: "师资专家", auth: false, bg: "#F1F4F6" },
    name: "teacher",
    component: () => import("../pages/teacher/index.vue"),
  },
  {
    path: "/teacherDetail",
    meta: { title: "师资详情", auth: false, bg: "#F1F4F6" },
    name: "teacherDetail",
    component: () => import("../pages/teacher/detail.vue"),
  },
  {
    path: "/apipcEnroll",
    meta: { title: "报名通知", auth: false, bg: "#F1F4F6" },
    name: "apipcEnroll",
    component: () => import("../pages/apipcEnroll/index.vue"),
  },
  {
    path: "/apipcEnrollDetail",
    meta: { title: "报名详情", auth: false, bg: "#F1F4F6" },
    name: "apipcEnrollDetail",
    component: () => import("../pages/apipcEnroll/detail.vue"),
  },
  {
    path: "/about",
    meta: { title: "关于我们", auth: false, bg: "#F1F4F6" },
    name: "about",
    component: () => import("../pages/about/index.vue"),
  },
  {
    path: "/member",
    meta: { title: "基础信息", bg: "#F1F4F6" },
    name: "member",
    component: () => import("../pages/member/index.vue"),
    children: [
      {
        path: "info",
        meta: { title: "基础信息", bg: "#F1F4F6" },
        name: "memberInfo",
        component: () => import("../pages/member/child/info.vue"),
      },
      {
        path: "account",
        meta: { title: "账号安全", bg: "#F1F4F6" },
        name: "memberAccount",
        component: () => import("../pages/member/child/account.vue"),
      },
      {
        path: "editPassword",
        meta: { title: "修改密码", bg: "#F1F4F6" },
        name: "editPassword",
        component: () => import("../pages/member/child/editPassword.vue"),
      },
      {
        path: "editPhone",
        meta: { title: "修改手机", bg: "#F1F4F6" },
        name: "editPhone",
        component: () => import("../pages/member/child/editPhone.vue"),
      },
      {
        path: "course",
        meta: { title: "我的课程", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/course.vue"),
      },
      {
        path: "material",
        meta: { title: "我的资料", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/material.vue"),
      },
      {
        path: "exerList",
        meta: { title: "我的练习", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/exerList.vue"),
      },
      {
        path: "wrongList",
        meta: { title: "错题集", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/wrongList.vue"),
      },
      {
        path: "courseCollection",
        meta: { title: "我的收藏", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/courseCollection.vue"),
      },
      {
        path: "materialCollection",
        meta: { title: "我的收藏", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/materialCollection.vue"),
      },
      {
        path: "exerCollection",
        meta: { title: "我的收藏", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/exerCollection.vue"),
      },
      {
        path: "application",
        meta: { title: "我的报名", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/application.vue"),
      },
      {
        path: "cert",
        meta: { title: "我的证书", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/cert.vue"),
      },
      {
        path: "certDetail",
        meta: { title: "我的证书", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/certDetail.vue"),
      },
      {
        path: "certTarget",
        meta: { title: "考证目标", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/certTarget.vue"),
      },
      {
        path: "myCert",
        meta: { title: "我的考证", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/myCert.vue"),
      },
      {
        path: "order",
        meta: { title: "订单列表", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/order.vue"),
      },
      {
        path: "orderDetail",
        meta: { title: "订单详情", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/orderDetail.vue"),
      },
      {
        path: "billing",
        meta: { title: "我的开票", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/billing.vue"),
      },
      {
        path: "applyInvoicing",
        meta: { title: "开票", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/applyInvoicing.vue"),
      },
      {
        path: "task",
        meta: { title: "我的班级", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/task.vue"),
      },
      {
        path: "taskDetail",
        meta: { title: "任务详情", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/taskDetail.vue"),
      },
      {
        path: "distribution",
        meta: { title: "分销记录", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/distribution.vue"),
      },
      {
        path: "dividends",
        meta: { title: "分红记录", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/dividends.vue"),
      },
      {
        path: "finance",
        meta: { title: "提现记录", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/finance.vue"),
      },
      {
        path: "applyFina",
        meta: { title: "申请提现", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/applyFina.vue"),
      },
      {
        path: "msg",
        meta: { title: "消息通知", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/msg.vue"),
      },
      {
        path: "suggestion",
        meta: { title: "投诉建议", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/suggestion.vue"),
      },
      {
        path: "userList",
        meta: { title: "人员列表", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/userList.vue"),
      },
      {
        path: "studyRecord",
        meta: { title: "学习记录", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/child/studyRecord.vue"),
      },
      {
        path: "certificate",
        meta: { title: "证书", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/child/certificate.vue"),
      },
      {
        path: "taskLedger",
        meta: { title: "任务台账", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/taskLedger.vue"),
      },
      {
        path: "taskLedgerDetail",
        meta: { title: "任务台账", bg: "#F1F4F6" },
        component: () => import("../pages/member/child/taskLedgerDetail.vue"),
      },
      {
        path: "userTaskProgress",
        meta: { title: "人员进度明细", bg: "#F1F4F6" },
        component: () =>
          import("../pages/member/child/child/userTaskProgress.vue"),
      },

      {
        path: "*",
        meta: { title: "404", bg: "#F1F4F6" },
        name: "404",
        component: notFound,
      },
    ],
  },

  {
    path: "/error",
    meta: { title: "错误", auth: false },
    name: "404",
    component: () => import("../pages/error.vue"),
  },
  {
    path: "*",
    meta: { title: "404", bg: "#F1F4F6" },
    name: "404",
    component: notFound,
  },
];

// 获取原型对象push函数
const originalPush = VueRouter.prototype.push;

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace;

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: "hash", // 明确指定哈希模式
  base: process.env.BASE_URL, // 确保基础路径正确
  routes,
});
router.beforeEach((to, from, next) => {
  const { title, auth } = to.meta;
  if (from && to.path !== from.path) {
    document.getElementById("app").scrollTop = 0;
  }
  if (
    !from.path.includes("login") &&
    to.path.includes("login") &&
    from.path !== "/"
  ) {
    localStorage.setItem("originHref", location.href);
  }
  if (!Token && !to.path.includes("login") && auth != false) {
    router.replace({ path: "/" });
  }
  if (title) {
    document.title = "筑才学院-" + title;
  }
  next();
});


export default router;
